// extracted by mini-css-extract-plugin
export default {"steps":"Steps_steps__4xAG+","heading":"Steps_heading__frylP","paragraph":"Steps_paragraph__b0oJt"};